import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import { AvatarComponent, AvatarSize } from '@recruitee/user-interface';

import {
  NOTE_AVATAR_UPDATE_STRATEGY,
  NoteAvatarAuthor,
  NoteAvatarInputValues,
  NoteAvatarUpdateStrategy,
} from './note-avatar.types';

@Component({
  selector: 'rt-note-avatar',
  imports: [AvatarComponent],
  templateUrl: './note-avatar.component.html',
  styleUrls: ['./note-avatar.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteAvatarComponent implements OnChanges {
  @Input()
  public author: NoteAvatarAuthor;

  @Input()
  public triggered: boolean | null;

  @Input()
  public size: AvatarSize = 'base';

  public data: NoteAvatarInputValues;

  constructor(
    @Inject(NOTE_AVATAR_UPDATE_STRATEGY) private updateStrategy: NoteAvatarUpdateStrategy,
  ) {}

  public ngOnChanges(changes: SimpleChanges) {
    if ('author' in changes || 'triggered' in changes) {
      this.data = this.updateStrategy.getValues({ author: this.author, triggered: this.triggered });
    }
  }
}
